import React, { useCallback, useMemo } from 'react';
import { useCreateAccountContext } from '@plug/contexts/CreateAccountContext';
import { Input, Select, Typography } from '@lomadee/design-system';
import { useFormikContext } from 'formik';
import { Flex } from 'rebass';
import UniqueCustomField from '../unique-custom-field';
import HublyFormInput from '@plug/ui/hubly-form-input';

const AffiliateRegistrationCustomFields = () => {
  const {
    initialValues,
    values: formikValues,
    setFieldValue,
    handleBlur,
    handleChange,
  } = useFormikContext<any>();
  const {
    whitelabelCustomization: { values, requirements },
    role,
    isFieldBlocked,
  } = useCreateAccountContext();

  const requirementsWithAdditionalFields = useMemo(() => {
    return requirements?.map(item => ({
      ...item,
      additionalFields: item?.additionalFields ? JSON.parse(item.additionalFields) : {},
    }));
  }, [requirements]);

  const getField = useCallback(
    (item: IAppRequirement & { additionalFields: any }) => {
      if (item.additionalFields?.values?.length) {
        return (
          <Flex flexDirection="column" style={{ gap: '12px' }}>
            <Typography color="neutralLow" size="XXS" fontWeight={500}>
              {item.value}
            </Typography>

            <Select
              width="100%"
              key={item.value}
              placeholder="Selecione um valor"
              items={item.additionalFields?.values?.map(value => ({ label: value, value }))}
              selected={{
                label: formikValues?.customFields[item.value],
                value: formikValues?.customFields[item.value],
              }}
              disabled={
                !!initialValues.customFields[item.value] &&
                isFieldBlocked(`customFields.${item.value}`)
              }
              onSelect={({ value }) => setFieldValue(`customFields.${item.value}`, value)}
            />
          </Flex>
        );
      }

      return (
        <HublyFormInput
          key={item.value}
          label={item?.additionalFields?.label || item.value}
          name={`customFields.${item.value}`}
          onChange={handleChange}
          value={formikValues?.customFields[item.value] ?? ''}
          helperText={item?.additionalFields?.helperText}
          onBlur={handleBlur}
          disabled={
            !!initialValues.customFields[item.value] && isFieldBlocked(`customFields.${item.value}`)
          }
          requirement={item}
          requirements={requirementsWithAdditionalFields}
          fluid
        />
      );
    },
    [
      formikValues,
      handleBlur,
      handleChange,
      initialValues.customFields,
      isFieldBlocked,
      requirementsWithAdditionalFields,
      setFieldValue,
    ],
  );

  const fields = useMemo(() => {
    if (!values) return <></>;

    const fields = values?.onboarding?.fields;

    return fields?.map(item => {
      if (!item) return <></>;

      const requirement = requirementsWithAdditionalFields.find(field => field.value === item.key);
      const subfield = item?.subfields[0];

      if (!requirement?.value) return <></>;

      if (!subfield) {
        return getField(requirement);
      }

      return (
        subfield &&
        formikValues?.customFields[subfield.key] === subfield?.condition?.value &&
        getField(requirement)
      );
    });
  }, [formikValues, getField, requirementsWithAdditionalFields, values]);

  return <>{fields}</>;
};

export default AffiliateRegistrationCustomFields;
